import useAuthenticatedApi from '@/src/Authentication/components/hooks/useAuthenticatedApi';
import useUserOrg from '@/src/Authentication/components/hooks/useUserOrg';

export default function useDeviceRegistration() {
    const authenticatedApi = useAuthenticatedApi();
    const { orgId } = useUserOrg();

    const registerDevice = async (deviceCode: string) => {
        try {
            const response = await authenticatedApi.put(
                `/${orgId}/registration/${deviceCode}/claim`,
            );

            if (response.status === 200) {
                return response.data;
            }
        } catch (error) {
            console.error(error);
        }

        return null;
    };

    return { registerDevice };
}
